<template>
  <div class="thanks" style="display:flex;align-items:center;justify-content:center;flex-direction:column;height:100%;">
    <div class="marquee">
      <div class="track">
        <template v-for="(img, i) in images.concat(images)" >
          <img :src="img" style="margin: 0 15px" />
        </template>
      </div>
    </div>
    <h1>MY STORY: SCUF + CORSAIR</h1>
    <div style="max-width: 700px;">
      <br>
      <img src="static/misc/bigb.jpg" style="max-width: 700px;">
      <p><span>During my tenure at SCUF, I helped the development of dozens of flagship product landing pages—Reflex, Instinct, Impact, Infinity4PS, and Exo—delivering a cohesive digital presence across four languages (English, French, German, and Italian) and seven distinct markets (US, UK, EU, INT, FR, DE, IT).

Building upon the foundational Instinct project, I rapidly mastered the Prismic headless CMS and Magento ecosystem under the mentorship of Aurelien & Andres. Through grit and hard work, I developed proficiency in architecting custom content types and slice structures, managing development and staging environments, and orchestrating seamless deployments to production.

This multifaceted experience enabled me to own the complete web product lifecycle—from conceptualizing content architecture to executing polished, market-ready landing pages—while maintaining consistency across diverse regional and linguistic contexts.
</span></p>
      <p><span>I also migrate large amounts of content/html/php structures from Magento into our Headless CMS Prismic. This is a process that has been going on since the beginning. Lots of things now live on Prismic instead of in Magento. The main benefit with this is keeping content asynchronous from the site and having the ability to be &quot;Headless&quot;. A few examples of features brought over from Magento to
          Prismic would be: building out a new language switcher with new attributes of continent &amp; currency. Redesigning the footer from an old style that lived in Magento into a new style in Prismic. Implementing breadcrumbs that had settings in Prismic.</span></p>
      <p><span>I oversaw the launches of the new products: Instinct and Reflex (technically the new Exo) that had very exciting things happen. I learned about caching, load balancing and the effects of sending thousands of people to a website can crash your servers (Reflex Drop V1 👀). I experienced what an intense holiday rush looks like. With multiple &quot;Releases&quot; happening on a schedule back-to-back from
          Black Friday to Christmas. I&apos;ve updated pages all along the way with UI/UX improvements, solved bugs and enjoyed coffees and lunches with the team.</span></p>
      <p><span><strong><u>Present: </u></strong>At present, there has just been a major launch of the Reflex Customization. Ongoing SEO and site improvements happening daily. Major Gaming Hub project to add to the site (along with a new content input process). Magento to Prismic migrations. XPCARE. New Reflex content. Homepage updates.&nbsp;</span></p>
      <p><span><strong><u>Conclusion:</u></strong> This is all to say it wouldn&apos;t have been possible without the team. I&apos;ve learned a lot in such a short time. I would say overall this has been one of the most exciting, challenging and rewarding parts of my career.</span></p>
      <p><br></p>
      <img style="max-width: 700px" src="static/misc/vision.jpg" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
      "static/c/3do.png",
      "static/c/amiga.png",
      "static/c/amstrad.png",
      "static/c/appleII.png",
      "static/c/atari2600.png",
      "static/c/atari5200.png",
      "static/c/atari7800.png",
      "static/c/atarijaguar.png",
      "static/c/atarilynx.png",
      "static/c/atarist.png",
      "static/c/colecovision.png",
      "static/c/coco.png",
      "static/c/c64.png",
      "static/c/dragon32.png",
      "static/c/dreamcast.png",
      "static/c/gameboyadvance.png",
      "static/c/gamecube.png",
      "static/c/gamegear.png",
      "static/c/gameboy.png",
      "static/c/gameboycolour.png",
      "static/c/genesis.png",
      "static/c/intellivision.png",
      "static/c/macintosh.png",
      "static/c/mame.png",
      "static/c/mastersystem.png",
      "static/c/msx.png",
      "static/c/neogeo.png",
      "static/c/ngp_black.png",
      "static/c/ngp.png",
      "static/c/n64.png",
      "static/c/nds.png",
      "static/c/nes.png",
      "static/c/oric.png",
      "static/c/pc.png",
      "static/c/pcengine.png",
      "static/c/tg16.png",
      "static/c/psx.png",
      "static/c/ps2.png",
      "static/c/psp.png",
      "static/c/samcoupe.png",
      "static/c/sega32x.png",
      "static/c/segacd.png",
      "static/c/sg-1000.png",
      "static/c/snes.png",
      "static/c/ti99.png",
      "static/c/trs-80.png",
      "static/c/vectrex.png",
      "static/c/videopac.png",
      "static/c/virtualboy.png",
      "static/c/wii.png",
      "static/c/wonderswan.png",
      "static/c/zxspectrum.png",
      "static/c/3do.png",
      "static/c/amiga.png",
      "static/c/amstrad.png",
      "static/c/appleII.png",
      "static/c/atari2600.png",
      "static/c/atari5200.png",
      "static/c/atari7800.png",
      "static/c/atarijaguar.png",
      "static/c/atarilynx.png",
      "static/c/atarist.png",
      "static/c/colecovision.png",
      "static/c/coco.png",
      "static/c/c64.png",
      "static/c/dragon32.png",
      "static/c/dreamcast.png",
      "static/c/gameboyadvance.png",
      "static/c/gamecube.png",
      "static/c/gamegear.png",
      "static/c/gameboy.png",
      "static/c/gameboycolour.png",
      "static/c/genesis.png",
      "static/c/intellivision.png",
      "static/c/macintosh.png",
      "static/c/mame.png",
      "static/c/mastersystem.png",
      "static/c/msx.png",
      "static/c/neogeo.png",
      "static/c/ngp_black.png",
      "static/c/ngp.png",
      "static/c/n64.png",
      "static/c/nds.png",
      "static/c/nes.png",
      "static/c/oric.png",
      "static/c/pc.png",
      "static/c/pcengine.png",
      "static/c/tg16.png",
      "static/c/psx.png",
      "static/c/ps2.png",
      "static/c/psp.png",
      "static/c/samcoupe.png",
      "static/c/sega32x.png",
      "static/c/segacd.png",
      "static/c/sg-1000.png",
      "static/c/snes.png",
      "static/c/ti99.png",
      "static/c/trs-80.png",
      "static/c/vectrex.png",
      "static/c/videopac.png",
      "static/c/virtualboy.png",
      "static/c/wii.png",
      "static/c/wonderswan.png",
      "static/c/zxspectrum.png",
      ]
    };
  }
};
</script>

<style scoped>
.thanks {
  background-color: floralwhite;
}

h1 {
  margin-top: -50px;
}

.marquee {
  position: relative;
  width: 100vw;
  max-width: 100%;
  height: 200px;
  padding: 20px 0 0;
  overflow-x: hidden;
}

.track {
  display: flex;
  width: max-content;
  align-items: center;
  white-space: nowrap;
  will-change: transform;
  animation: marquee 300s linear infinite;
  backface-visibility: hidden;
}

@keyframes marquee {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}
</style>


// WEBPACK FOOTER //
// src/page/Thankyouscuf.vue